import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { Report, User } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class ReportService implements RequestService {

  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'Report';  // URL to web api

  constructor(
    private http: HttpClient,
    ) { }



  /**
  * Generates a Job Report
  * @param uuid - job uuid
  * @param type - type of report
  * @param addInfo - additional info
  **/
  generateJobReport(uuid:string, type:string, addInfo:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}job/report`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();

    urlSearchParams.append('jobUUID',uuid);
    urlSearchParams.append('reportType',type);
    urlSearchParams.append('includeAdditonalInfo',addInfo);
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Report[]>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }


  getJobReports(uuid:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}job/reports/${uuid}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Report>(url,{
       //params : httpParams
       headers: headers
    })

  }


  /**
  * Generates a Page Report
  * @param uuid - job uuid
  * @param type - type of report
  * @param addInfo - additional info
  **/
  generatePageReport(uuid:string, type:string, addInfo:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}page/report`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();

    urlSearchParams.append('pageUUIDs',uuid);
    urlSearchParams.append('reportType',type);
    urlSearchParams.append('includeAdditonalInfo',addInfo);
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Report[]>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }

  getPageReports(uuid:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}page/reports/${uuid}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Report>(url,{
       //params : httpParams
       headers: headers
    })

  }




  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better Report of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/report.service.ts